"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverrideHeaderEnums = void 0;
var OverrideHeaderEnums;
(function (OverrideHeaderEnums) {
    OverrideHeaderEnums["TenantIdOverride"] = "tenant-id-override";
})(OverrideHeaderEnums = exports.OverrideHeaderEnums || (exports.OverrideHeaderEnums = {}));
